import { HardwareDevice } from "./getSiteIngestion";
import axiosConfig from "./axiosConfig";

export interface UnmappedDevice {
  id: string;
  name: string;
  deviceCategory: string;
  energyLocation: string;
}

export interface ReduxiControllerDevicesResponse {
  controller_id: string;
  reduxi_devices: Record<string, HardwareDevice>;
  unmapped_devices: UnmappedDevice[];
}

const getReduxiControllerDevices = async (
  authToken: string,
  controllerId: string
): Promise<ReduxiControllerDevicesResponse> => {
  const { data } = await axiosConfig.get(
    `/ingestion/reduxi_controller_devices`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      params: { controllerId },
    }
  );
  return data;
};

export default getReduxiControllerDevices;
